/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */

export default {
  'sidebar.administracion': 'Administration',
  'sidebar.banco': 'Bank',
  'banco.agregarBanco': 'Create Bank',
  'banco.confirmacionCreacion': 'Are you sure to create the registry?',
  'banco.confirmacionEdicion': 'You are sure you want to edit the registry?',
  'banco.confirmacionEliminacion': 'Are you sure you want to delete the registry?',
  'banco.modificarBanco': 'Edit Bank',
  'banco.eliminarBanco': 'Delete Bank',
  'banco.codigoBanco': 'Code Bank',
  'banco.nombreBanco': 'Name Bank',
  'banco.estadoBanco': 'State',
  'banco.banco': 'Bank',
  'banco.verBanco': 'View Bank',
};
